// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".asterik-font[data-v-24fae370]{width:15px;height:20px;color:#21292f!important}", ""]);
// Exports
module.exports = exports;
